import React, { useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'

import { StylePanelProps } from '@/lib/stylePanel'
import useResponsivePadding from '@/lib/useResponsivePadding'

import styles from './Assetbanner.module.css'
export type AssetbannerProps = {
  variant?: string
  title?: string
  subtitle?: string
  content?: React.ReactNode
  list?: string[]
  button?: React.ReactNode
  asset?: {
    src?: string
    alt?: string
    focus?: string
  }
  assetLink?: {
    url: string
    target: string
  }
  compact?: boolean
} & StylePanelProps

export const PhnxAssetbanner: React.FC<AssetbannerProps> = ({
  variant = 'primary',
  title,
  subtitle,
  content,
  list,
  button,
  asset,
  padding,
  backgroundColor = '#252A30',
  textColor = '#FFF',
  compact = false,
  assetLink,
}) => {
  const paddingStyles = useResponsivePadding(padding)
  const style = {
    ...paddingStyles,
    color: textColor,
    backgroundColor: backgroundColor,
  }

  const isDesktop = useMediaQuery({ query: '(min-width: 1048px)' })
  const [imageUri, setImageUri] = React.useState<string>('')

  useEffect(() => {
    if (asset?.src) {
      const imageHeightWidth = isDesktop ? '460x460' : '270x270'
      let imageUri = `${asset.src}/m/${imageHeightWidth}/filters:quality(80)`

      if (asset?.focus) {
        imageUri = `${imageUri}:focal(${asset.focus})`
      }
      setImageUri(imageUri)
    }
  }, [asset, isDesktop])

  return (
    <div style={style} className="stylepanel">
      {}
      <style jsx>{`
        stylepanel {
          ${paddingStyles}
        }
      `}</style>
      <div className={`${styles['assetbanner']} ${styles[compact ? 'compact' : '']}`}>
        <div className={`${styles['assetbanner-container']} container`}>
          <div className={styles['assetbanner-content']}>
            {title && <p className={`title`}>{title}</p>}
            {subtitle && <h1 className={styles['bruce-subtitle']}>{subtitle}</h1>}
            <div className={styles.content}>
              {content}

              {list && list.length > 0 && (
                <ul>
                  {list.map((item, index) => (
                    <li key={index}>
                      <div className={styles.icon}>
                        <img src="../../../../../assets/check.webp" alt="check mark" />
                      </div>
                      <div className="content">{item}</div>
                    </li>
                  ))}
                </ul>
              )}

              {(isDesktop || variant === 'primary') && button && (
                <div className="button">{button}</div>
              )}
            </div>
          </div>
          {asset && asset.src && (
            <div
              className={`${styles['assetbanner-img']} ${variant === 'secondary' ? styles.secondaryAlignment : ''}`}
            >
              {assetLink && assetLink.url !== undefined && assetLink.url !== '' ? (
                <a href={assetLink.url} target={assetLink.target}>
                  <img src={imageUri} alt={asset.alt} />
                </a>
              ) : (
                <img src={imageUri} alt={asset.alt} />
              )}
            </div>
          )}
          {!isDesktop && variant === 'secondary' && button && <div>{button}</div>}
        </div>
      </div>
    </div>
  )
}
